import './VerticalColumn.scss';
import { Col, Space } from 'antd';
import React from 'react';
export const VerticalColumn = ({ children }) => React.createElement(Col, { className: 'vertical-column', span: 12 },
    React.createElement(Space, { direction: 'vertical', size: 8 }, children));
